module.exports = __webpack_public_path__ + "img/success.4e115ae7.png";